import React from 'react';
import DragAndDrop from '../Photos/DragAndDrop';
import style from './NewPatientInfo.module.css';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { Button } from '@material-ui/core';

const NewPatientProfilePic = ({ handleDrop, disabled = false, profilePicData, onFileChange, rotate, removeFile }) => {
    const renderFileInput = !profilePicData?.data && !disabled;
    return (
        <DragAndDrop handleDrop={handleDrop} disabled={disabled}>
            <div className={style.imageUploadArea}>
                {renderFileInput && <span>Upload patient profile picture (optional)</span>}
                {renderFileInput ? (
                    <div className={style.uploadBtnWrapper}>
                        <button className={style.uploadBtn}>+</button>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={onFileChange}
                            name="patientImage"
                            id="patientImage"
                            disabled={disabled}
                        />
                    </div>
                ) : (
                    <div style={{ margin: 16 }}>
                        <img
                            style={{
                                width: '100%',
                                maxWidth: 400,
                                marginTop: '7%',
                                transform: `rotateZ(${profilePicData.rotate}deg)`,
                            }}
                            src={profilePicData.data}
                        />
                        <button onClick={removeFile} className={disabled ? style.removeDisable : style.remove}>
                            <DeleteOutlinedIcon />
                        </button>
                    </div>
                )}
            </div>

            {profilePicData?.data && (
                <div className={style.uploadFooter}>
                    <Button onClick={(e) => rotate && rotate(e, 'rotateLeft')}>
                        <RotateLeftIcon />
                    </Button>
                    <Button onClick={(e) => rotate && rotate(e, 'rotateRight')}>
                        <RotateRightIcon />
                    </Button>
                </div>
            )}
        </DragAndDrop>
    );
};

export default NewPatientProfilePic;
